import { render, staticRenderFns } from "./AllDemandsBP.vue?vue&type=template&id=70827723&scoped=true"
import script from "./AllDemandsBP.vue?vue&type=script&lang=js"
export * from "./AllDemandsBP.vue?vue&type=script&lang=js"
import style0 from "./AllDemandsBP.vue?vue&type=style&index=0&id=70827723&prod&lang=scss"
import style1 from "./AllDemandsBP.vue?vue&type=style&index=1&id=70827723&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70827723",
  null
  
)

export default component.exports